import { alertsReducer as alerts } from './alerts';
import { archiveViewReducer as archiveView } from './archiveView';
import { contactViewReducer as contactView } from './contactView';
import { contextMenuReducer as contextMenu } from './contextMenu';
import { duplicatesViewReducer as duplicatesView } from './duplicatesView';
import { groupViewReducer as groupView } from './groupView';
import { linkedinProfileViewReducer as linkedinProfileView } from './linkedinProfileView';
import { locationReducer as location } from './location';
import { modalReducer as modal } from './modal';
import { navBarReducer as navBar } from './navBar';
import { scrollPositionReducer as scrollPosition } from './scrollPosition';
import { selectedReducer as selected } from './selected';
import { viewRestorationReducer as viewRestoration } from './viewRestoration';
import { welcomeGuideReducer as welcomeGuide } from './welcomeGuide';
import { sourceLabelsReducer as sourceLabels } from './sourceLabels';
import { panelSizingReducer as panelSizing } from './panelSizing';
import {
  AlertsState,
  ArchiveViewState,
  BxUIState,
  ContactViewState,
  ContextMenuState,
  DuplicatesViewState,
  GroupViewState,
  LinkedInProfileViewState,
  LocationState,
  ModalState,
  NavBarState,
  PanelSizingState,
  ScrollPositionState,
  SelectedState,
  SourceLabelsState,
  ViewRestorationState,
  WelcomeGuideState,
} from '@repo/utils/types';

export interface AppUI {
  alerts: AlertsState;
  archiveView: ArchiveViewState;
  bx: BxUIState;
  contactView: ContactViewState;
  contextMenu: ContextMenuState;
  duplicatesView: DuplicatesViewState;
  groupView: GroupViewState;
  linkedinProfileView: LinkedInProfileViewState;
  location: LocationState;
  modal: ModalState;
  navBar: NavBarState;
  panelSizing: PanelSizingState;
  scrollPosition: ScrollPositionState;
  selected: SelectedState;
  sourceLabels: SourceLabelsState;
  viewRestoration: ViewRestorationState;
  welcomeGuide: WelcomeGuideState;
}

export default {
  alerts,
  archiveView,
  contactView,
  contextMenu,
  duplicatesView,
  groupView,
  linkedinProfileView,
  location,
  modal,
  navBar,
  panelSizing,
  scrollPosition,
  selected,
  sourceLabels,
  viewRestoration,
  welcomeGuide,
};
